<template>
  <div>
<!--    <table-picker/>-->
    <data-table-pagination
        ref="dataTable"
        :title="$t(translation + '.title')"
        :headers="headers"
        :translation="translation"
        :append-item="dataTablePaginationData.addItem"
        :edit-item="dataTablePaginationData.editItem"
        :delete-item="dataTablePaginationData.deleteItem"
        :api-read="dataTablePaginationData.apiRead"
        @success-delete="dataTablePaginationData.deleteItem = null"
        @success-append="dataTablePaginationData.addItem = null"
        @success-edit="dataTablePaginationData.editItem = null"
    >
      <template v-slot:toolbarAction>
        <v-btn color="primary" @click="addItem()">
          <v-icon dark>mdi-plus</v-icon>
          {{ $t('general.add') }}
        </v-btn>
        <v-btn class="ml-2" color="warning" @click="$refs.dataTable.resetData()">
          <v-icon dark>mdi-refresh</v-icon>
        </v-btn>
      </template>
      <template v-slot:action-buttons="{item}">

        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
                v-bind="attrs"
                v-on="on"
                color="warning"
                icon
                @click="editItem(item)"
            >
              <v-icon>mdi-pencil-outline</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('general.edit') }}</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
                v-bind="attrs"
                v-on="on"
                color="error"
                icon
                :loading="deleteLoadingId === item.id"
                @click="deleteItem(item)">
              <v-icon>{{ item.is_active ? 'mdi-delete' : 'mdi-backup-restore' }}</v-icon>
            </v-btn>
          </template>
          <span>{{ item.is_active ? $t('general.delete') : $t('general.return') }}</span>
        </v-tooltip>
      </template>
    </data-table-pagination>

    <universal-dialog
        v-if="dialog.show"
        :title="dialog.title"
        :show-dialog="dialog.show"
        @close="closeDialog"
    >
      <universal-form
          ref="refForm"
          v-if="dialog.show"
          :fields="form.fields"
          :edit-item="form.item"
          @submit-form="handleSubmitData"
      />
      <template v-slot:dialogActions>
        <v-sheet class="text-end" width="100%">
          <v-spacer/>
          <v-btn @click="closeDialog" :disabled="loading" color="error">
            {{ $t('general.cancel') }}
          </v-btn>
          <v-btn
              class="ml-5"
              @click="getFormData"
              :loading="loading"
              color="primary">
            {{ form.item !== null ? $t('general.edit') : $t('general.add') }}
          </v-btn>
        </v-sheet>
      </template>
    </universal-dialog>
  </div>
</template>

<script>
/* eslint-disable */

import UniversalForm from "@/components/UniversalForm";
import DataTablePagination from "@/components/DataTablePagination";
import UniversalDialog from "@/components/UniversalDialog";
import {CRUD_VARS} from "@/utils/consts";
import {mapMutations} from "vuex";
import {
  addItem,
  closeDialog,
  deleteItem,
  editItem,
  generateHeaders,
  generateFields,
  handleSubmitData,
  showSwalPopUpConfirmation,
  getFormData
} from "@/utils/functions";
import {validationRules} from "@/utils/validationRules";
// import TablePicker from "@/components/TablePicker";

export default {
  name: "CitiesView",
  components: {
    'universal-form': UniversalForm,
    "data-table-pagination": DataTablePagination,
    "universal-dialog": UniversalDialog,
    // "table-picker": TablePicker
  },
  data() {
    return {
      translation: "cities",
      loading: false,
      deleteLoadingId: -1,

      dataTablePaginationData: {
        apiRead: '/api/os_cities/index',
        addItem: null,
        editItem: null,
        deleteItem: null
      },
      form: {
        fields: [],
        item: null
      },
      ...CRUD_VARS
    }
  },
  computed: {
    headers() {
      return this.generateHeaders([
        {key: "updated_at", text: this.$t(this.translation + '.updated_at')},
        {key: "name", text: this.$t(this.translation + '.name')},
        {key: "post_code", text: this.$t(this.translation + '.post_code')},
        {key: "countries.name", text: this.$t(this.translation + '.country')},
        {key: "is_active", text: this.$t(this.translation + '.active')},
        {key: "actions", text: this.$t('general.actions'), sortable: false}
      ])
    },
  },
  created() {
    this.apiStore =  "/api/os_cities/store"
    this.apiUpdate= "/api/os_cities/update"
    this.apiDelete= "/api/os_cities/destroy"
    this.sucMessageEdit= this.$t(this.translation + '.sucMessageEdit')
    this.sucMessageStore= this.$t(this.translation + '.sucMessageStore')
    this.sucMessageDelete= this.$t(this.translation + '.sucMessageDelete')
    this.sucMessageReturn= this.$t(this.translation + '.sucMessageReturn')
    this.form.fields = this.generateFields([
      {
        cols: 12,
        name: this.$t(this.translation + '.country'),
        type: "virtual",
        model: "os_country_id",
        item_value: "id",
        item_text: "name",
        api_read: "/api/os_countries/index_active",
        rules: [validationRules.required]
      },
      {
        cols: 12,
        name: this.$t(this.translation + '.post_code'),
        model: "post_code",
        rules: [validationRules.required]

      },
      {
        cols: 12,
        name: this.$t(this.translation + '.name'),
        model: "name",
        rules: [validationRules.required]

      }
    ]);
  },
  methods: {
    ...mapMutations("snackbar", {
      setSnackbar: "setSnackbar"
    }),
    closeDialog,
    addItem,
    generateFields,
    showSwalPopUpConfirmation,
    generateHeaders,
    editItem,
    deleteItem,
    handleSubmitData,
    getFormData
  }
}
</script>

<style scoped>

</style>
